import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Layout from '@/components/feature/Layout';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { articles } from '@/mocks/data';

const articleCategories = ['全部', '攻略教程', '平台资讯'];

export default function Articles() {
  const [activeCategory, setActiveCategory] = useState('全部');

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const filtered =
    activeCategory === '全部'
      ? articles
      : articles.filter((a) => a.category === activeCategory);

  return (
    <Layout>
      <Breadcrumb
        items={[
          { label: '首页', path: '/' },
          { label: '攻略资讯' },
        ]}
      />
      <section className="w-full px-4 md:px-6 py-8 md:py-12">
        <div className="max-w-7xl mx-auto">
          <div className="mb-8">
            <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
              攻略资讯
            </h1>
            <p className="text-sm md:text-base text-foreground-500">
              掌握PG国际008最新动态与游戏攻略技巧
            </p>
          </div>

          <div className="flex items-center gap-2 mb-8 flex-wrap">
            {articleCategories.map((cat) => (
              <button
                key={cat}
                onClick={() => setActiveCategory(cat)}
                className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
                  activeCategory === cat
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-50 border border-background-200/70 text-foreground-600 hover:border-primary-200/60'
                }`}
              >
                {cat}
              </button>
            ))}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {filtered.map((article) => (
              <Link
                key={article.id}
                to={`/article/${article.slug}`}
                className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200/60 transition-all duration-300 cursor-pointer"
              >
                <div className="relative h-52 overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    title={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-background-50/90 text-xs font-medium text-foreground-700">
                    {article.category}
                  </span>
                </div>
                <div className="p-5">
                  <h2 className="text-base font-semibold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                    {article.title}
                  </h2>
                  <p className="text-sm text-foreground-500 line-clamp-2 mb-4">{article.excerpt}</p>
                  <div className="flex items-center justify-between text-xs text-foreground-400">
                    <span>{article.date}</span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {article.views}
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
}